import React from 'react'

export const StockListGrouping = () => {
  return <div>StockListGrouping</div>
}
